<app-auth-header></app-auth-header>

<div
  class="relative h-[100%] bg-cover bg-center text-white flex bg-[rgb(76,151,212)]"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-80"></div>
  <div
    class="fixed z-10 flex !justify-center w-[87vw] h-[85.3vh] ml-[5.5rem] bg-[#F1F3F5] rounded-[8px] mt-[20px]"
  >
    <div class="relative z-10 margin-top-[30px] w-[100%]">
      <div class="mt-[40px] flex items-center">
        <mat-icon class="text-black ml-[3rem] cursor-pointer" (click)="navigateTo()">chevron_left</mat-icon>
        <span class="text-[1.5rem] font-extrabold Poppins text-[#E76B3F] mx-auto">
          Choose a Subscription
        </span>
      </div>
      
      
      <div class="mt-[7.5rem] flex justify-evenly w-[100%] ">
        <!-- Basic Plan -->
        <div class="group">
          <div
            class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[19vw] h-[48vh] flex items-center pb-[50px] pl-[20px]"
          >
            <div
              class="w-[363px] h-[ 505px]  "
              style="
                border: 0.818px solid rgba(32, 61, 84, 0.3);
                box-shadow: 0px 0px 5.393px 0px rgba(10, 116, 243, 0.25);
              "
            >
              <div class="h-[100%] flex flex-col">
                <div class="h-[110px] bg-[#E76B3F] z-10">
                  <div
                    class="flex justify-center items-center text-center text-[#F1F3F5] text-[1.27rem] mt-[3rem] font-medium h-[10.451vh]"
                  >
                    <div class="mt-8">
                      Basic Plan
                      <div
                        class="flex-auto my-[4px] text-center !text-[0.75838rem]"
                      >
                        3 Months
                      </div>

                      <div
                        class="bg-[#E76B3F] text-[#F1F3F5] border-[4px] border-[!F1F3F5] rounded-full w-[7rem] h-[7rem] flex items-center justify-center shadow-lg"
                      >
                        <span class="text-2xl font-bold">Free</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-[#F1F3F5] group-hover:bg-[#fdf0ec] flex-1">
                  <div
                    class="w-[100%] mt-[23px] pt-[0.5rem] px-[19px] text-[#203D54]"
                  >
                    <div class="mt-[50px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Users
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto !bg-[#f5f5f5] mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Projects
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            AI Based
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Documents
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Contracts
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Role and Permission
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-[20px] mb-2">
                    <div class="flex justify-center mt-[13px]">
                      <button
                        (click)="handleFreeTrial()"
                        class="flex bg-[#FFF] text-[#E76B3F] w-[14vw] font-medium border-[2px] border-[#E76B3F] h-[51px]  !mb-[1rem]  justify-center items-center flex-shrink-0 rounded-[32px]  text-[16px] cursor-pointer"
                        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                      >
                        Get Started
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Standard Plan -->
        <div class="group">
          <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[19vw] h-[48vh] flex items-center pb-[50px] "

          >
            <div
              class="w-[363px] h-[ 505px]  "
              style="
                border: 0.818px solid rgba(32, 61, 84, 0.3);
                box-shadow: 0px 0px 5.393px 0px rgba(10, 116, 243, 0.25);
              "
            >
              <div class="h-[100%] flex flex-col">
                <div
                  class="h-[110px] bg-[#E76B3F] z-10"
                >
                  <div
                    class="flex justify-center items-center text-center text-[#F1F3F5] text-[1.27rem] mt-[3rem] font-medium h-[10.451vh]"
                  >
                    <div class="mt-10">
                      Standard
                      <div
                        class="flex-auto my-[8px] text-center !text-[0.75838rem]"
                      >
                        6 Months
                      </div>

                      <div
                        class="bg-[#E76B3F] text-[#F1F3F5] border-[4px] border-[#F1F3F5] rounded-full w-[7rem] h-[7rem] flex flex-col justify-center items-center shadow-lg"
                      >
                        <span class="text-[0.68rem] font-normal font-Poppins"
                          >Save 29%</span
                        >
                        <span class="text-2xl font-bold">$50</span>
                        <span class="text-[0.68rem] font-normal font-Poppins"
                          >$35 / Month</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-[#F1F3F5] group-hover:bg-[#fdf0ec] flex-1"
                >
                  <div class="w-[100%] mt-[23px] px-[19px] text-[#203D54]">
                    <div class="mt-[80px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Users
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Projects
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            AI Based
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Documents
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Contracts
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Role and Permission
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-[20px] mb-2">
                    
                    <div class="flex justify-center mt-[13px]">
                      <button
                      (click)="navigateToPaymentDetail()"
                      class="flex bg-[#FFF] text-[#E76B3F] w-[14vw] font-medium border-[2px] border-[#E76B3F] h-[51px]  !mb-[1rem]  justify-center items-center flex-shrink-0 rounded-[32px]  text-[16px] cursor-pointer"
                      style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                    >
                        Select this plan
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- premium plan -->
        <div class="group">
          <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[19vw] h-[48vh] flex items-center pb-[50px] "

          >
            <div
              class="w-[363px] h-[ 505px]  "
              style="
                border: 0.818px solid rgba(32, 61, 84, 0.3);
                box-shadow: 0px 0px 5.393px 0px rgba(10, 116, 243, 0.25);

              "
            >
              <div class="h-[100%] flex flex-col">
                <div class="h-[110px] bg-[#E76B3F] z-10">
                  <div
                    class="flex justify-center items-center text-center text-[#F1F3F5] text-[1.27rem] mt-[3rem] font-medium h-[10.451vh]"
                  >
                    <div class="mt-8">
                      Premium
                      <div
                        class="flex-auto my-[4px] text-center !text-[0.75838rem]"
                      >
                      1 Year
                      </div>

                      <div
                        class="bg-[#E76B3F] text-[#F1F3F5] border-[4px] border-[!F1F3F5] rounded-full w-[7rem] h-[7rem] flex items-center justify-center shadow-lg"
                      >
                        <span class="text-2xl font-bold">$ 100</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-[#F1F3F5] group-hover:bg-[#fdf0ec] flex-1"
                >
                  <div class="w-[100%] mt-[23px] px-[19px] text-[#203D54]">
                    <div class="mt-[80px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Users
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Projects
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            AI Based
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Documents
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center opacity-50 cursor-not-allowed">
                        <mat-icon>lock</mat-icon>
                      
                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Contracts
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%]"
                          ></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Role and Permission
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-[20px] mb-2">
                   
                    <div class="flex justify-center mt-[13px]">
                      <button
                      (click)="navigateToPaymentDetail()"
                      class="flex bg-[#FFF] text-[#E76B3F] w-[14vw] font-medium border-[2px] border-[#E76B3F] h-[51px]  !mb-[1rem]  justify-center items-center flex-shrink-0 rounded-[32px]  text-[16px] cursor-pointer"
                        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                      >
                      Select this plan
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Elite plan -->
        <div class="group">
          <div
          class="transform group-hover:-translate-y-1 transition-transform duration-300 w-[19vw] h-[48vh] flex items-center pb-[50px]"
          >
            <div
              class="w-[363px] h-[ 505px]  "
              style="
                border: 0.818px solid rgba(32, 61, 84, 0.3);
                box-shadow: 0px 0px 5.393px 0px rgba(10, 116, 243, 0.25);
              "
            >
              <div class="h-[100%] flex flex-col">
                <div class=" h-[110px] bg-[#E76B3F] z-10">
                  <div
                    class="flex justify-center items-center text-center text-[#F1F3F5] text-[1.27rem] mt-[3rem] font-medium h-[10.451vh]"
                  >
                    <div class="mt-8">
                      Elite
                      <div
                        class="flex-auto my-[4px] text-center !text-[0.75838rem]"
                      >
                      1 Month
                      </div>

                      <div
                        class="bg-[#E76B3F] text-[#F1F3F5] border-[4px] border-[!F1F3F5] rounded-full w-[7rem] h-[7rem] flex items-center justify-center shadow-lg"
                      >
                        <span class="text-2xl font-bold">$150</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-[#F1F3F5] group-hover:bg-[#fdf0ec]  flex-1"
                >
                  <div class="w-[100%] mt-[23px] px-[19px] text-[#203D54]">
                    <div class="mt-[80px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Users
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Projects
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] opacity-50 items-center">
                        <mat-icon>lock</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            AI Based
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] opacity-50 items-center">
                        <mat-icon>lock</mat-icon>
                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Documents
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Contracts
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="mt-[10px]">
                      <div class="flex px-[12px] items-center">
                         <mat-icon class="text-[#1AA260] pr-[10px]">check_circle</mat-icon>

                        <div class="w-[100%]">
                          <span class="text-[16px] font-normal ml-[15px]">
                            Role and Permission
                          </span>
                          <div
                            class="ml-[15px] mr-[15px] flex-auto mt-[0px] w-[100%] opacity-50"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-[20px] mb-2">
                   
                    <div class="flex justify-center mt-[13px]">
                      <button
                        (click)="navigateToPaymentDetail()"
                        class="flex bg-[#FFF] text-[#E76B3F] !w-[14vw] font-medium border-[2px] border-[#E76B3F] h-[51px]  !mb-[1rem]  justify-center items-center flex-shrink-0 rounded-[32px]  text-[16px] cursor-pointer"
                        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
                      >
                        Select this plan
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
